module.exports = __webpack_public_path__ + "static/media/close-2.96a35f2e.svg";